import { Col, Row } from "react-bootstrap";
import { LabelCol } from "./LabelCol";

export const InfoRow = ({
  label,
  value,
}: {
  label: string;
  value?: string;
}) => {
  return (
    <Row className="mb-2">
      <LabelCol className="col-6">{label + ":"}</LabelCol>
      <Col className="text-left">{value}</Col>
    </Row>
  );
};
